import { H2, P } from '@dnb/eufemia';
import type { ApiDto } from '@portals/shared/portal/ApiDto';
import Markdown from '@portals/shared-frontend/components/Markdown';
import { ErrorContext } from '@portals/shared-frontend/hooks';
import { type JSX, useContext } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';

import Container from '@/components/Container';
import Page from '@/components/Page';

export default function ApiTermsOfUse(): JSX.Element {
  const { setGlobalError } = useContext(ErrorContext);
  const { apiSlug } = useParams();

  const { data: apis, isValidating: apisLoading } = useSWR<ApiDto[]>(`/api`);
  const api = apis?.find(({ slug }) => slug === apiSlug);

  if (!apisLoading && !api) {
    setGlobalError(404);
  }

  return (
    <Page skeleton={apisLoading} subtitle="Terms of use" title={api?.name}>
      <Container size="small">
        <H2>{api?.name} API - Terms of use</H2>
        {api?.termsOfUseUpdatedAt && (
          <P size="x-small" top="small">
            Last updated: {new Date(api.termsOfUseUpdatedAt).toUTCString()}
          </P>
        )}
        {api?.termsOfUse ? (
          <Markdown>{api.termsOfUse}</Markdown>
        ) : (
          <P top="medium">{`The ${api?.name} does not have terms of use defined`}</P>
        )}
      </Container>
    </Page>
  );
}
